import React from 'react'
import Page from '../components/Page'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane, Form, FormFeedback, FormGroup, FormText, Input } from 'reactstrap'
import axios from '../utils/posAxios'
import StorageService from '../services/StorageService'
import { MdCameraAlt, MdFace, MdDone, MdClear, MdCreate, MdAdd } from 'react-icons/md'
import { BsPlusSquareFill } from 'react-icons/bs'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Redirect } from 'react-router'
import classnames from 'classnames'
import { IconContext } from 'react-icons/lib'
import PosPromoForm from '../components/PosPromoForm'

class PosPromoTable extends React.Component {
  _isMounted = true
  constructor(props) {
    super(props)
    this.state = {
      promoList: [],
      modal: false,
      confirmModal: false,
      id: '',
      name: '',
      promo_code: '',
      promo_type: '',
      options: '',
      mod_value: '',
      compare_type: '',
      compare_value: '',
      start_date: '',
      end_date: '',
      issue_limit: '',
      claim_limit: '',
      issued: '',
      selectedId: '',
      selectedData: '',
    }
  }

  componentDidMount() {
    this.Promo()
  }
  componentWillUnmount() {
    this._isMounted = false
  }

  Promo = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }

    let fullUrl,
      store_id = ''
    if (!this.props.isGlobal) {
      store_id = this.props.data.store_id
      data.store_id = store_id
      fullUrl = url + ':3001/v1/store/promo'
    } else {
      fullUrl = url + ':3001/v1/promo'
    }

    axios
      .post(fullUrl, data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }

        if (this._isMounted) {
          this.setState({
            promoList: result.data,
            store_id: store_id,
            isGlobal: this.props.isGlobal,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  toggle = (action, id) => () => {
    return this.setState({
      modal: !this.state.modal,
      isEdit: id != undefined || (id != null && action == 'EDIT') ? true : false,
      selectedId: id != undefined || (id != null && action == 'EDIT') ? id : '',
    })
  }

  toggleConfirmModal = (name, id) => () => {
    return this.setState({
      confirmModal: !this.state.confirmModal,
      selectedData: name,
      selectedId: id,
    })
  }

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    })

    this.setState({
      modal: false,
    })

    if (reload) {
      window.location.reload()
    } else {
      this.Promo()
    }
  }

  delete = () => {
    const user = StorageService.getSession('user_info')
    const url = process.env.REACT_APP_UNITY_API2_URL

    let data, fullUrl
    if (this.state.isGlobal) {
      data = {
        session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
        promo_id: this.state.selectedId,
        delete_by: user.email,
      }
      fullUrl = url + ':3001/v1/promo/delete'
    } else {
      data = {
        session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
        promo_id: this.state.selectedId,
        store_id: this.props.data.store_id,
        remove_by: user.email,
      }
      fullUrl = url + ':3001/v1/store/promo/remove'
    }

    axios
      .post(fullUrl, data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          })
          return
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: `Shipping ${this.state.isGlobal ? 'deleted' : 'removed'} successfully.`,
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ confirmModal: false })
        this.Promo()
      })
      .catch(error => {
        alert(error)
      })
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />
    }
    return (
      <>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />
        <div className="text-right mb-3">
          <div className="ps-btn-group">
            <Button color="link" onClick={this.toggle('ADD', null)}>
              <IconContext.Provider value={{ color: '#2a2c6b' }}>
                <BsPlusSquareFill size={25} />
              </IconContext.Provider>
            </Button>
          </div>
        </div>
        <Table responsive hover className="ps-table tb-col-13">
          <thead>
            <tr>
              <th>Name</th>
              <th>Code</th>
              <th>Type</th>
              <th>Options</th>
              <th>Mod</th>
              <th>Compare Type</th>
              <th>Compare Value</th>
              <th>Start</th>
              <th>End</th>
              <th>Issue Limit</th>
              <th>Issued</th>
              <th>Claim Limit</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {this.state.promoList.length < 1 && (
              <tr>
                <td colSpan="13">
                  <div className="ps-empty-data">
                    <div className="empty-content">
                      <MdCreate />
                      <h4>No data to show</h4>
                      <span>Click the 'Create' button to add new promo</span>
                    </div>
                  </div>
                </td>
              </tr>
            )}

            {this.state.promoList.length > 0 &&
              this.state.promoList.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>{item.name}</td>
                    <td>{item.promo_code}</td>
                    <td>{item.promo_type}</td>
                    <td>{item.options}</td>
                    <td>{item.mod_value}</td>
                    <td>{item.compare_type}</td>
                    <td>{item.compare_value}</td>
                    <td>{item.start_date}</td>
                    <td>{item.end_date}</td>
                    <td>{item.issue_limit}</td>
                    <td>{item.issued}</td>
                    <td>{item.claim_limit}</td>
                    <td>
                      <div className="ps-action-button">
                        {this.state.isGlobal && (
                          <Button className="theme-button theme-button-secondary" onClick={this.toggle('EDIT', item.id)}>
                            Edit
                          </Button>
                        )}
                        <Button className="theme-button theme-button-primary-light" onClick={this.toggleConfirmModal(item.name, item.id)}>
                          {this.state.isGlobal ? 'Delete' : 'Remove'}
                        </Button>
                      </div>
                    </td>
                  </tr>
                )
              })}
          </tbody>
        </Table>
        <Modal isOpen={this.state.modal} toggle={this.toggle()} className={this.props.className} centered>
          <PosPromoForm history={this.props.history} onToggleModal={this.toggle} closeModal={this.closeModal} match={this.props.match} data={this.state} />
        </Modal>

        <Modal isOpen={this.state.confirmModal} toggle={this.toggleConfirmModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <ModalHeader toggle={this.toggleConfirmModal()}>{this.state.isGlobal ? 'Delete' : 'Remove'} Promo</ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <p>
                  Are you sure you want to {this.state.isGlobal ? 'delete' : 'remove'} {this.state.selectedData} ?
                </p>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button className="theme-button theme-button-secondary" onClick={this.toggleConfirmModal()}>
              No
            </Button>
            <Button className="theme-button theme-button-primary" onClick={() => this.delete()}>
              Yes
            </Button>
          </ModalFooter>
        </Modal>
      </>
    )
  }
}

export default PosPromoTable
